var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getLatestPointInfo)?_c('div',[_c('make-point-header'),_vm._v(" "),_c('make-point-info'),_vm._v(" "),_c('make-point-btn')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }